let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4Wlui")).then(() => parcelRequire('2RrDc'));